import { Modal, ModalProps as antDModalProps } from "antd";
import React, { ReactElement } from "react";
import CloseModalSVG from "./icons/CloseModalSVG.svg";
import "./index.less";

interface CustomModalProps {
    setVisible: (flag: boolean) => void;
    renderHeader?: ReactElement | string;
    onClickClose?: () => void;
    closeWhenClickCloseBtn?: boolean;
}

export type ModalProps = CustomModalProps & antDModalProps;

export const CustomModal: React.FC<ModalProps> = ({
    className,
    renderHeader,
    children,
    closeWhenClickCloseBtn = true,
    onClickClose,
    setVisible,
    ...props
}) => {
    return (
        <Modal
            centered
            className={`selfModal ${className}`}
            closeIcon={
                <div
                    className="modal-close-icon"
                    onClick={() => {
                        onClickClose && onClickClose();
                        closeWhenClickCloseBtn && setVisible?.(false);
                    }}
                >
                    <img src={CloseModalSVG} />
                </div>
            }
            destroyOnHidden={true}
            maskClosable={false}
            width={440}
            {...props}
        >
            {renderHeader && (
                <div className="modal-header">
                    {typeof renderHeader === "string" ? <span>{renderHeader}</span> : renderHeader}
                </div>
            )}
            {children}
        </Modal>
    );
};
